import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/oilTankCost',
    meta: { title: '油罐费用' },
    component: Layout,
    redirect: '/oilTankCost/list',
    children: [
      {
        path: 'list',
        meta: { title: '仓库费用', activeMenu: '/oilTankCost' },
        component: () => import('@/views/oilTankCost/OilTankCost.vue')
      },
      {
        path: 'detail',
        meta: { title: '仓库费用详情', activeMenu: '/oilTankCost' },
        component: () => import('@/views/oilTankCost/OilTankCostDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增仓库费用', activeMenu: '/oilTankCost' },
        component: () => import('@/views/oilTankCost/OilTankCostAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑仓库费用', activeMenu: '/oilTankCost' },
        component: () => import('@/views/oilTankCost/OilTankCostAdd.vue')
      }

    ]
  }

]
